import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, takeEvery, takeLatest } from 'redux-saga/effects';
import { AdressVerzeichnisRequestModel, AdressVerzeichnisResponse, Status } from '@ps20/bff-models';
import {
  AddressvorschlagAction,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { ADRESSVORSCHLAG_FAILED_REASON, App } from '@ps20-frontend/frontend-models';
import { AxiosError } from 'axios';
import { safeSaga } from '@ps20-frontend/safe-saga';

export const URL_ADRESSVERZEICHNIS = '/privatschutz/api/adressverzeichnis';

export function* adressvorschlagSaga(): SagaIterator {
  yield takeLatest(GlobalActions.GET_ADDRESSVORSCHLAG, safeSaga(getAdressvorschlag, App.SHOP));
  yield takeEvery(
    GlobalActions.ADRESSDATEN_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(GlobalActions.ADRESSDATEN_REQUEST_FAILED, safeSaga(errorCallback, App.SHOP));
}

export function* getAdressvorschlag(action: GlobalAction<AddressvorschlagAction>): SagaIterator {
  const payload = action.payload;

  if (payload.plz) {
    const plzRequest: AdressVerzeichnisRequestModel = {
      plz: payload.plz,
      ortschaft: null,
      strasse: null,
      hausnummer: null,
      nurOrteRequired: payload.callerData != null && payload.callerData.nurOrte === true,
    };

    const globalPut = GlobalPut.getInstance();
    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequest({
        appId: App.SHOP,
        body: plzRequest,
        url: URL_ADRESSVERZEICHNIS,
        successEvent: GlobalActions.ADRESSDATEN_REQUEST_SUCCESSFUL,
        errorEvent: GlobalActions.ADRESSDATEN_REQUEST_FAILED,
        originEvent: action,
      }),
    );
  }
}

export function* successCallback(
  successAction: DoRequestResponse<AdressVerzeichnisResponse, AdressVerzeichnisRequestModel>,
): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const resp: AdressVerzeichnisResponse = successAction.payload;
  const originalEvent = successAction.doRequestAction.payload.originEvent;
  const nurOrteRequired = successAction.doRequestAction.payload.body.nurOrteRequired;

  const errorCallEffect = call(
    [globalPut, globalPut.put],
    new GlobalActions().adressvorschlaegeFailed({
      callerId: originalEvent.payload.callerId,
      callerData: originalEvent.payload.callerData,
      reason: ADRESSVORSCHLAG_FAILED_REASON.PLZ_INVALID,
    }),
  );

  if (resp.status === Status.NOK) {
    return yield errorCallEffect;
  }
  if (!resp.orte || resp.orte.filter(Boolean).length === 0) {
    return yield errorCallEffect;
  }
  if (!nurOrteRequired && !resp.strassen) {
    return yield errorCallEffect;
  }
  if (!nurOrteRequired && resp.strassen.filter(Boolean).length === 0) {
    return yield errorCallEffect;
  }

  return yield call(
    [globalPut, globalPut.put],
    new GlobalActions().adressvorschlaegeReceived({
      strassen: resp.strassen,
      orte: resp.orte,
      callerId: originalEvent.payload.callerId,
      callerData: originalEvent.payload.callerData,
    }),
  );
}

export function* errorCallback(errorAction: DoRequestResponse<AxiosError>): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const originalEvent = errorAction.doRequestAction.payload.originEvent;
  yield call(
    globalPut.put,
    new GlobalActions().adressvorschlaegeFailed({
      callerId: originalEvent.payload.callerId,
      callerData: originalEvent.payload.callerData,
      reason: ADRESSVORSCHLAG_FAILED_REASON.SERVICEDOWN,
    }),
  );
}
